import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { SnackBarService } from "./snackbar.service";
import { MaintenanceDto } from "../model/maintenance.model";
import { BatchSynchronisation } from '../model/batch-synchronisation.model'
import { MaintenanceLogErrors } from '../model/maintenance-log-errors.model'
import { MaintenanceBatchSynchronisation } from '../model/maintenance-batch-synchronisation.model'

@Injectable({
  providedIn: 'root'
})

export class MaintenanceService {

  constructor(
    protected http: HttpClient,
    private snackBarService: SnackBarService
  ) {
  }

  public resourceUrl = environment.apiServerUrl + 'maintenance';

  getMaintenanceInfos(): Observable<HttpResponse<MaintenanceDto>> {
    return this.http.get<MaintenanceDto>(this.resourceUrl, {observe: 'response'});
  }

  getMaintenanceLogErrors(dateDebut: string, dateFin: string, sortBy: string, sortDirection: string): Observable<HttpResponse<MaintenanceLogErrors[]>> {
    return this.http.get<MaintenanceLogErrors[]>(`${this.resourceUrl}/maintenance-log-errors?dateDebut=${dateDebut}&dateFin=${dateFin}&sortBy=${sortBy}&sortDirection=${sortDirection}`, {observe: 'response'});
  }

  updateMaintenanceInfos(maintenanceTemplateUpdateDto: MaintenanceDto) {
    return this.http
      .put<MaintenanceDto>(`${this.resourceUrl}`, maintenanceTemplateUpdateDto, {observe: 'response'})
      .subscribe(
        value => {
          this.snackBarService.showSuccess('Les données ont été enregistrées avec succès', {durationInSeconds: 2});
        },
        (err) => {
          this.snackBarService.showError(err);
        }
      );
  }

  syncStructures() {
      return this.http
                 .put<BatchSynchronisation>(`${this.resourceUrl}/sync-structures`, {observe: 'response'});
  }

  syncNotifications() {
    return this.http
               .put<BatchSynchronisation>(`${this.resourceUrl}/sync-notifications`, {observe: 'response'});
  }

  syncAdherents() {
    return this.http
               .put<BatchSynchronisation>(`${this.resourceUrl}/sync-adherents`, {observe: 'response'});
  }

  getBatchInfos(): Observable<HttpResponse<MaintenanceBatchSynchronisation>> {
      return this.http.get<MaintenanceBatchSynchronisation>(`${this.resourceUrl}/batch-synchronisations`, {observe: 'response'});
  }

  getBatchInfosByCategorie(categorie: string): Observable<HttpResponse<BatchSynchronisation>> {
    return this.http.get<BatchSynchronisation>(`${this.resourceUrl}/batch-synchronisation-by-categorie?categorie=${categorie}`, {observe: 'response'});
  }

}
